import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ProductName } from '../../models';
import { modalStyle, productCellStyle } from './add-product-modal.styles';
import { ANALYTICS_EVENTS } from '../../constants';

export interface ProductModalProps {
  productList: ProductName[];
  onSelectProduct: (product: ProductName) => void;
}

const ProductModal = ({ productList, onSelectProduct }: ProductModalProps) => {
  const { createAnalyticsEvent } = useAnalyticsEvents();
  const updateAnalyticsEvent = (product: ProductName) => {
    createAnalyticsEvent({
      action: 'click',
      component: 'button',
      trackEventName: ANALYTICS_EVENTS.selectProduct,
      productName: product
    }).fire();
  };
  const handleClick = (product: ProductName) => {
    onSelectProduct(product);
    updateAnalyticsEvent(product);
  };
  const handleKeyDown = (event: { key: string }, product: ProductName) => {
    if (event.key === 'Enter') {
      onSelectProduct(product);
      updateAnalyticsEvent(product);
    }
  };

  return (
    <div css={modalStyle}>
      {productList.map((productName) => (
        <div
          role="button"
          tabIndex={0}
          key={productName}
          css={productCellStyle}
          onClick={() => handleClick(productName)}
          onKeyDown={(event) => handleKeyDown(event, productName)}
          aria-label={`Select ${productName}`}
        >
          {productName}
        </div>
      ))}
    </div>
  );
};

export default ProductModal;
